// extracted by mini-css-extract-plugin
module.exports = {"title":"_c3bb212c","description":"_666b78ca"};